
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Coins, MapPin, Phone, Truck, Star, Waves } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const AchatMetauxHerault = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat Métaux Hérault (34) - Rachat Fer Cuivre Montpellier Béziers | Groupe Fabre"
        description="Rachat de métaux dans l'Hérault : fer, cuivre, aluminium. Service Montpellier, Béziers, Sète. Solutions littorales, pesée certifiée."
        canonical="/nos-services/achat-metaux/herault"
        keywords="achat métaux Hérault, rachat cuivre Montpellier, ferraille 34, métaux Béziers Sète"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-cyan-600 to-cyan-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="flex items-center mb-4">
                <Waves className="h-12 w-12 mr-4" />
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold">Achat Métaux Hérault</h1>
                  <p className="text-xl mt-2 opacity-90">Rachat de métaux du littoral méditerranéen au 34</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                  Rachat de métaux dans l'Hérault (34)
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>Groupe Fabre Environnement</strong> propose ses services d'achat de métaux 
                  dans tout l'<strong>Hérault</strong>. Nous intervenons à Montpellier, 
                  Béziers, Sète et dans toutes les communes du département 34, du littoral à l'arrière-pays.
                </p>
                
                <h3 className="text-xl font-bold text-fabre-gray mb-4">Zones d'intervention Hérault</h3>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-cyan-600 mr-3 mt-1" />
                    <span><strong>Montpellier :</strong> métropole et technopôle</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-cyan-600 mr-3 mt-1" />
                    <span><strong>Béziers :</strong> capitale viticole</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-cyan-600 mr-3 mt-1" />
                    <span><strong>Sète :</strong> port méditerranéen</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-cyan-600 mr-3 mt-1" />
                    <span><strong>Littoral :</strong> stations balnéaires</span>
                  </li>
                </ul>

                <div className="bg-cyan-50 border border-cyan-200 p-6 rounded-lg">
                  <h4 className="font-bold text-cyan-800 mb-3">Spécialités littorales</h4>
                  <ul className="text-cyan-700 text-sm space-y-2">
                    <li>• Métaux marins résistants à la corrosion</li>
                    <li>• Équipements portuaires et nautiques</li>
                    <li>• Installations touristiques et balnéaires</li>
                    <li>• Matériel viticole et agricole</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-fabre-gray mb-6">Expertise méditerranéenne</h3>
                <p className="text-gray-600 mb-6">
                  Notre connaissance des spécificités côtières nous permet de valoriser 
                  au mieux vos métaux exposés aux embruns et conditions marines.
                </p>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Waves className="h-5 w-5 text-cyan-600 mr-3" />
                    <span>Spécialiste métaux marins</span>
                  </div>
                  <div className="flex items-center">
                    <Coins className="h-5 w-5 text-cyan-600 mr-3" />
                    <span>Valorisation optimale</span>
                  </div>
                  <div className="flex items-center">
                    <Truck className="h-5 w-5 text-cyan-600 mr-3" />
                    <span>Couverture Hérault</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-cyan-600 mr-3" />
                    <span>Service premium</span>
                  </div>
                </div>

                <Link to="/contact" className="block">
                  <button className="w-full px-6 py-3 bg-cyan-600 text-white rounded-md font-medium hover:bg-cyan-700 transition-colors">
                    Demander un devis Hérault
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetauxHerault;
